import './IndividualBook.css'
import BookLayout from '../book-layout/BookLayout'
import { useEffect } from 'react';
export default function IndividualBook({book}) {

    useEffect(() => {
        document.title = book.bookName + " - Scott A. Young";
      });

      
    return (
        <div className='individual-book-page-content'>

            <BookLayout book={book} showBuyLinks last={true} hasLink={false} blurbNoVanish={true} />
            
        </div>
    )
}
